import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { last, split } from 'ramda';
import { Row, Col } from 'antd';
import Cropper from 'react-cropper';

const getImageBody = (imageUrl) => last(split(';base64,', imageUrl));

export default class ProfileAvatarCrop extends Component {
    static propTypes = {
        imageUrl: PropTypes.string.isRequired,
    }

    state = {
        cropped: null
    }

    getData = () => {
        return getImageBody(this.state.cropped);
    }

    onCrop = () => {
        const canvas = this.cropper.getCroppedCanvas();
        this.setState({ cropped: canvas.toDataURL() });
    }

    render() {
        const { cropped } = this.state;
        const { imageUrl } = this.props;

        return (
            <Row type='flex' align='middle' gutter={20}>
                <Col sm={16}>
                    <Cropper
                        ref={node => this.cropper = node}
                        src={imageUrl}
                        crop={this.onCrop}
                        aspectRatio={1}
                        zoomable={false}
                        draggable={false}
                        viewMode={1}
                        style={{height: 400}}
                    />
                </Col>
                <Col sm={8}>
                    <div className='profile-cropped-preview' style={{ backgroundImage: `url(${cropped})` }} />
                </Col>
            </Row>
        )
    }
}
